import { DynamicEmsDataDto, DynamicEmsDataModel } from '../../types'

/**
 * Transforms dynamic EMS data from backend to frontend model.
 */
export const fromDynamicEmsDataDtoToModel = (dto: DynamicEmsDataDto[]): DynamicEmsDataModel[] => {
  return dto.map(data => ({
    start: data.start,
    end: data.end,
    emsBatteryMode: data.emsBatteryMode,
    emsSgReadyMode: data.emsSgReadyMode,
  }))
}
